import React from 'react';

/**
 * Toolbar component for GuiBuilder
 * Contains version tag input, publish toggle, Edit/View modes, and save button
 */
export default function Toolbar({
    versionTag,
    setVersionTag,
    isPublished,
    setIsPublished,
    designerMode,
    setDesignerMode,
    setPreviewPageIndex,
    setPreviewSelections,
    setShowIntroFrontPage = () => {},
    defaultPreviewSelections = {},
    handleSave,
    saving,
    overrideCount = 0
}) {
    const selectMode = (mode) => {
        if (mode === 'view' && designerMode !== 'view') {
            setPreviewPageIndex(0);
            setPreviewSelections(defaultPreviewSelections);
            setShowIntroFrontPage(true);
        }
        setDesignerMode(mode);
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'var(--bg-secondary)',
            padding: '1rem 1.5rem',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius)',
            gap: '1rem'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Version Tag:</span>
                    <input 
                        type="text" 
                        className="input-field" 
                        style={{ width: '180px', padding: '0.4rem', margin: 0, fontSize: '0.85rem' }} 
                        value={versionTag}
                        onChange={e => setVersionTag(e.target.value)}
                        placeholder="1.0.0"
                    />
                </div>
                <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                    <input 
                        type="checkbox" 
                        checked={isPublished} 
                        onChange={e => setIsPublished(e.target.checked)} 
                    />
                    Publish this layout version
                </label>
            </div>
            
            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <div style={{ display: 'inline-flex', border: '1px solid var(--border)', borderRadius: 'var(--radius)', overflow: 'hidden' }}>
                    <button
                        type="button"
                        onClick={() => selectMode('edit')}
                        style={{
                            border: 'none',
                            borderRight: '1px solid var(--border)',
                            background: designerMode === 'edit' ? 'var(--text-primary)' : 'var(--bg-primary)',
                            color: designerMode === 'edit' ? 'var(--bg-primary)' : 'var(--text-primary)',
                            padding: '0.5rem 0.8rem',
                            fontSize: '0.85rem',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fa-solid fa-pen-to-square" style={{ marginRight: '0.35rem' }}></i>
                        Edit
                    </button>
                    <button
                        type="button"
                        onClick={() => selectMode('view')}
                        style={{
                            border: 'none',
                            background: designerMode === 'view' ? 'var(--text-primary)' : 'var(--bg-primary)',
                            color: designerMode === 'view' ? 'var(--bg-primary)' : 'var(--text-primary)',
                            padding: '0.5rem 0.8rem',
                            fontSize: '0.85rem',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fa-solid fa-eye" style={{ marginRight: '0.35rem' }}></i>
                        View
                    </button>
                </div>
                <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
                    {overrideCount} override{overrideCount === 1 ? '' : 's'}
                </span>
                <button 
                    onClick={handleSave} 
                    className="btn-primary" 
                    style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', padding: '0.5rem 1rem', background: 'var(--text-primary)', color: 'var(--bg-primary)' }}
                    disabled={saving}
                >
                    <i className="fa-regular fa-floppy-disk"></i>
                    {saving ? 'Saving...' : 'Save Layout'}
                </button>
            </div>
        </div>
    );
}
